<template>
  <foldable-card
    non-foldable
    title="Employees Upload History"
    description="View your past uploads for employee monitoring."
  >
    <v-data-table
      class="main-table"
      :headers="headers"
      :items="items"
      hide-default-footer
      disable-sort
      :options="tableOptions"
    >
      <template v-slot:item.submissionDate="{ value }">
        {{ value | formatDate("MM/dd/yyyy HH:mm") }}
      </template>
    </v-data-table>
  </foldable-card>
</template>

<script>
import FoldableCard from "@/components/FoldableCard";
import { employeesUploadAPI } from "@/services/api";
import { get } from "@/services/request";
import hasNotifications from "@/mixins/has-notifications";
import { formatDate } from "@/services/format";

const tableOptions = {
  itemsPerPage: -1
};

export default {
  name: "EmployeesUploadHistory",
  mixins: [hasNotifications],
  data: () => ({
    headers: [
      { text: "Submission Date", value: "submissionDate" },
      { text: "File Name", value: "filename" },
      { text: "User Submitted", value: "username" },
      { text: "Partial Upload", value: "partialUpload" }
    ],
    tableOptions,
    items: []
  }),
  created() {
    get(employeesUploadAPI)
      .then(response => {
        if (response && response.data) {
          this.items = response.data;
        }
      })
      .catch(error => {
        const errorMessage = "Error loading employees upload history";
        console.error(errorMessage, error);

        this.showMessage({
          mode: "error",
          text: errorMessage
        });
      });
  },
  components: {
    FoldableCard
  },
  filters: {
    formatDate
  }
};
</script>
